import { Source } from '../../models/Source'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    isOpen: boolean
    onClose: () => void
    source: Source
    onDelete: () => void
    onShowList: () => void
}

export const SourceModal = ({ isOpen, onClose, source, onShowList, onDelete }: Props) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={source.displayTitle}
            onNavigateBack={onShowList}
            footer={
                <Button intent="secondaryDestructive" onClick={onDelete}>
                    Delete card
                </Button>
            }
        >
            <div className="flex flex-col items-stretch justify-start gap-y-6">
                {source.displayBankName && (
                    <WorkflowPage.IconSection
                        title="Bank"
                        icon="bank.large"
                        description={source.displayBankName}
                    />
                )}

                <WorkflowPage.IconSection
                    title="Expires"
                    icon="calendar.large"
                    description={source.displayExpiresString}
                />
            </div>
        </Modal>
    )
}
